import html2canvas from "html2canvas";
import JsPDF from "jspdf";
// eslint-disable-next-line import/no-extraneous-dependencies
import * as XLSX from "xlsx/xlsx";

/* O jsPDF desenha cada <canvas> no PDF como JPEG (o formato está fixo no
   addImage do context2d dele), e JPEG não tem transparência: o fundo
   transparente dos gráficos do chart.js virava preto no arquivo exportado.

   A correção é deixar o canvas opaco antes da captura, pintando branco POR
   BAIXO do que já está desenhado (destination-over). Na tela não muda nada — o
   fundo atrás do gráfico já é branco — e as barras semitransparentes continuam
   compondo certo, agora sobre o branco em vez do preto. */
const flattenCanvasBackgrounds = element => {
  element?.querySelectorAll("canvas").forEach(canvas => {
    const context = canvas.getContext("2d");

    if (!context) return;

    context.save();
    context.globalCompositeOperation = "destination-over";
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.restore();
  });
};

export const elementToPDF = (id, fileName) => {
  const htmlSource = document.getElementById(id);

  flattenCanvasBackgrounds(htmlSource);

  const doc = new JsPDF({
    orientation: "p",
    unit: "px",
    format: "a4",
    hotfixes: ["px_scaling"]
  });

  const opt = {
    callback(doc) {
      doc.save(fileName);
    },
    x: 50,
    y: 25,
    autoPaging: "text",
    html2canvas: {
      allowTaint: true,
      dpi: 300,
      letterRendering: true,
      logging: false,
      scale: 0.5
    }
  };
  doc.html(htmlSource, opt);
};

export const arrayToCSV = (array, fileName) => {
  let csvContent = "";
  array.forEach((infoArray, index) => {
    const dataString = infoArray.join(";");
    csvContent += index < array.length ? `${dataString}\n` : dataString;
  });

  const download = (content, file, mimeType) => {
    let a = document.createElement("a");
    const fileMimeType = mimeType || "application/octet-stream";

    if (navigator.msSaveBlob) {
      // IE10
      navigator.msSaveBlob(
        new Blob([content], {
          type: fileMimeType
        }),
        file
      );
    } else if (URL && "download" in a) {
      a.href = URL.createObjectURL(
        new Blob([content], {
          type: fileMimeType
        })
      );
      a.setAttribute("download", file);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      window.location.href = `data:application/octet-stream,${encodeURIComponent(
        content
      )}`;
    }
  };

  download(csvContent, fileName, "text/csv;encoding:utf-8");
};

export const arrayToXLSX = (array, fileName) => {
  const sheet = XLSX.utils.aoa_to_sheet(array);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, sheet, "Sheet1");

  const fileBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([fileBuffer], { type: "application/octet-stream" });

  const download = (content, file) => {
    const a = document.createElement("a");
    const url = URL.createObjectURL(content);
    a.href = url;
    a.download = file;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  download(blob, fileName);
};

export const arrayToXLS = (array, fileName) => {
  const sheet = XLSX.utils.aoa_to_sheet(array);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, sheet, "Sheet1");

  const fileBuffer = XLSX.write(wb, { bookType: "xls", type: "array" });
  const blob = new Blob([fileBuffer], { type: "application/vnd.ms-excel" });

  const download = (content, file) => {
    const a = document.createElement("a");
    const url = URL.createObjectURL(content);
    a.href = url;
    a.download = file;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  download(blob, fileName);
};
